<template>
	<header class="basic-header hidden-print">
		<nav class="navbar-suite">
			<div class="nav-inner-wrap">
				<div id="navbar-students" class="col-sm-4 col-md-3 col-xs-10">
					<ul class="nav navbar-nav navbar-left" role="navigation" style="display: block;" v-if="role !== 'none'">
						<li class="dropdown">
							<a class="dropdown-toggle nowrap"
								 data-toggle="dropdown"
								 role="button"
								 aria-haspopup="true"
								 aria-expanded="false"
								 @click.prevent="studentDropdownIsExpanded = !studentDropdownIsExpanded">
								<div class="navbar-student-image img-circle">
									<img :src="selectedStudent.PHOTO_URL" :alt="selectedStudent.NAME" class="img-fluid"
											 v-if="!!selectedStudent">
									<img :src="`/CommunityWebPortal/_app/includes/static/images/profiles/no-image.png`"
											 alt="Default profile image"
											 class="img-fluid default-profile-img"
											 v-else>
								</div>
								<span
									class="navbar-selected-student-name"
									v-tooltip.bottom-center="{
										content: !!selectedStudent ? `${ selectedStudent.FIRST_NAME } ${ selectedStudent.LAST_NAME }` :
											$t('MAIN_CONTENT.Header.selectAStudent'),
										trigger: 'hover click'
									}"
								>
									<template v-if="!!selectedStudent">
										{{ selectedStudent.FIRST_NAME }} {{ selectedStudent.LAST_NAME }}
									</template>
									<template v-else>
										{{ $t('MAIN_CONTENT.Header.selectAStudent') }}
									</template>
									<font-awesome-icon icon="chevron-down"
																		v-if="!studentDropdownIsExpanded">
									</font-awesome-icon>
									<font-awesome-icon icon="chevron-up"
																		 v-else>
									</font-awesome-icon>
								</span>
							</a>
							<ul class="dropdown-menu" :class="{'show-menu': studentDropdownIsExpanded}">
								<li class="dropdown-header selected-student-header-item" v-if="role === 'student'">
									{{ $t('MAIN_CONTENT.Header.myStudentProfileTitleCase') }}
								</li>
								<li class="dropdown-header selected-student-header-item" v-else-if="!!selectedStudent">
									{{ $t('MAIN_CONTENT.Header.currentStudentProfileTitleCase') }}
								</li>
								<li class="selected-student-item" v-if="!!selectedStudent">
									<a class="pointer" @click.prevent="setSelectedStudentAndGoToWelcomeScreen(selectedStudent.STUDENT_RID)">
										<div class="row">
											<div class="col-xs-3">
												<div class="navbar-student-image img-circle">
													<img :src="selectedStudent.PHOTO_URL" :alt="selectedStudent.NAME" class="img-fluid">
												</div>
											</div>
											<div class="col-xs-9">
												<strong>{{selectedStudent.FIRST_NAME}} {{selectedStudent.LAST_NAME}}</strong>
												<ul class="list-unstyled">
													<li v-for="(school, index) in selectedStudent.ENROLLMENT"
															:key="`${school.SCHOOL_ID}_${index}`">
														{{ $t('MAIN_CONTENT.commonContent.sideMenuGradeLabel') }} {{ school.GRADE_LEVEL }}
														<br />{{ school.SCHOOL_TITLE }}
													</li>
												</ul>
											</div>
										</div>
									</a>
								</li>
								<li class="dropdown-header" v-if="role === 'parent'">{{ $t('MAIN_CONTENT.Header.sideNavMyStudents') }}</li>
								<li v-for="student in unselectedStudents" :key="student.STUDENT_RID" class="student-item">
									<a class="pointer" @click.prevent="setSelectedStudentAndGoToWelcomeScreen(student.STUDENT_RID)">
										<div class="row">
											<div class="col-xs-3">
												<div class="navbar-student-image img-circle">
													<img :src="student.PHOTO_URL" :alt="student.NAME" class="img-fluid">
												</div>
											</div>
											<div class="col-xs-9">
												<strong>{{student.FIRST_NAME}} {{student.LAST_NAME}}</strong>
												<ul class="list-unstyled">
													<li v-for="(school, index) in student.ENROLLMENT" :key="`${school.SCHOOL_ID}_${index}`">
														{{ $t('MAIN_CONTENT.commonContent.sideMenuGradeLabel') }} {{ school.GRADE_LEVEL }}
														<br />{{ school.SCHOOL_TITLE }}
													</li>
												</ul>
											</div>
										</div>
									</a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
				<div id="navbar-brand" class="col-sm-3 col-md-5 hidden-xs text-center">
					<h1 class="header-title">
						<i :class="`sf sf-${suiteModule}`" aria-hidden="true" :title="title"></i>
						<span :class="{ 'sr-only' : srOnly, 'visible-lg-inline': true }">
							{{ title }}
						</span>
					</h1>
				</div>
				<div id="navbar-account" class="col-xs-2 col-sm-5 col-md-4 text-right" v-if="showNav">
					<ul class="nav navbar-nav navbar-right" role="navigation" style="display: block;">
						<li class="active hidden-xs" v-if="role !== 'none'">
							<a href="#" @click="navigateToHomePage()">
								<font-awesome-icon icon="home"></font-awesome-icon> 
								<template v-if="!isAboveMaxLength()">
									<span class="visible-lg-inline">
										{{ $t('MAIN_CONTENT.commonContent.homeHeaderLink') }}
									</span> 
									<span class="sr-only">
										{{ $t('MAIN_CONTENT.commonContent.currentHeaderLabel') }}
									</span>
								</template>
							</a>
						</li>
						<li class="hidden-xs">
							<help-button linkClass="rudder-help" :disableText="!isAboveMaxLength()" />
						</li>
						<li class="dropdown">
							<a href="#"
								 class="dropdown-toggle text-right"
								 data-toggle="dropdown"
								 role="button"
								 aria-haspopup="true"
								 aria-expanded="false"
								 @click.prevent="isExpanded = !isExpanded">
								<span class="hidden-xs">
									<template v-if="role === 'student'">{{ $t('MAIN_CONTENT.Header.account') }}</template>
									<template v-else>{{ profile.USER_FIRST_NAME }} {{ profile.USER_LAST_NAME }}</template>
									<font-awesome-icon icon="chevron-down" style="color: #FFFFFF;" v-if="!isExpanded"></font-awesome-icon>
									<font-awesome-icon icon="chevron-up" style="color: #FFFFFF;" v-else></font-awesome-icon>
								</span>
								<span class="visible-xs-inline">
									<font-awesome-icon icon="ellipsis-v" style="color: #FFFFFF;"></font-awesome-icon>
								</span>
							</a>
							<ul class="dropdown-menu" :class="{'show-menu': isExpanded}">
								<li v-if="role !== 'none' && !userIsAdmin">
									<a class="pointer" @click="updateRoute('/account-settings/general')">
										{{ $t('MAIN_CONTENT.Header.accountSettingsHeaderLabel') }}
									</a>
								</li>
								<template v-if="userIsAdmin">
									<li>
										<a href="javascript:void(0);" @click.prevent="switchAdminRole">
											<template v-if="role === 'student'">
												{{ $t( 'MAIN_CONTENT.Header.switchToParentView' ) }}
											</template>
											<template v-if="role === 'parent'">
												{{ $t( 'MAIN_CONTENT.Header.switchToStudentView' ) }}
											</template>
										</a>
									</li>
									<li>
										<a href="javascript:void(0);" @click.prevent="showLocaleDialog = true">
											{{ $t( 'MAIN_CONTENT.Header.changeLanguage' ) }}
										</a>
									</li>
								</template>
								<li>
									<a href="#" @click="logout">
										{{ $t('MAIN_CONTENT.Header.logoutHeaderLabel') }}
									</a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</nav>
		<!-- Locale Selection -->
		<template v-if="showLocaleDialog">
			<!-- Modal -->
			<modal :modal-title="$t('MAIN_CONTENT.General.languageSelectionTitle')"
							:show="showLocaleDialog"
							dialog-size="sm"
							name="courseRequestModal"
							@close="!selectedLocale && $store.state.role !== 'admin' ? '' : showLocaleDialog = false">
				<template slot-scope="modalProps">
					<p class="text-center text-muted">
						{{ $t('MAIN_CONTENT.General.languageSelectionTitle') }}
					</p>
					<!-- Language Selection -->
					<div class="col-xs-12">
						<strong>
							{{ $t('MAIN_CONTENT.General.selectLanguage') }}
						</strong>
					</div>
					<div class="form-group">
						<select
							name="localeSelection"
							id="localeSelect"
							class="form-control"
							v-model="selectedLocale"
						>
							<option v-for="( locale, localeIndex ) in locales"
											:value="locale.LOCALE_ID"
											:key="`locale_${localeIndex}`">
								{{ locale.LOCALE_DISPLAY_TEXT }}
							</option>
						</select>
					</div>
				</template>
				<template slot="footer">
					<button type="button"
									class="btn btn-transparent pull-right"
									@click="switchLanguageDisplay()">
						{{ $t('MAIN_CONTENT.commonContent.submitButton') }}
					</button>
				</template>
			</modal>
		</template>
	</header>
</template>

<script>
	import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
	import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
	import moment from 'moment';

	import Modal from 'COMMONS/shared/Modal/Modal.vue';

	import HelpButton from './HelpButton.vue';

	import Locales from '../../api/Locales';

	/**
	 * @vue-prop {String} suiteModule - The Sapphire module in view
	 * @vue-prop {String} [ title = 'Sapphire Suite' ] - Title in header
	 * @vue-prop {Boolean} [ showNav = false ] - Show the header navigation, true/false
	 * @vue-prop {Boolean} [ srOnly = false ] - Header title is only visible to screen readers, true/false
	 * @vue-prop {Boolean} [ fullWidth = true ] - Header is full width of window, true/false
	 * @vue-prop {Boolean} [ useSave = false ] - Header save button is disabled
	 * @vue-computed {String} fullName - The logged-in user's full name
	*/
	export default {
		name: 'HeaderBar',
		props: {
			suiteModule : {
				type: String,
				required: true
			},
			title: {
				type:			String,
				default:	'Sapphire Suite'
			},
			showNav: {
				type:			Boolean,
				default:	true
			},
			srOnly: {
				type:			Boolean,
				default:	false
			},
			fullWidth: {
				type:			Boolean,
				default:	true
			}
		},
		components: {
			HelpButton,
			Modal,
		},
		directives: {
			'tooltip': VTooltip,
		},
		data() {
			return {
				isExpanded: false,
				studentDropdownIsExpanded: false,
				showLocaleDialog: false,
				selectedLocale: '',
				locales: [],
			};
		},
		computed: {
			...mapState(['profile', 'useSave', 'students']),
			...mapGetters([ 'selectedStudent', 'role', 'roleRules', 'userIsAdmin', 'profileLocale', 'adminLocale', 'getSelectedLocale', ]),
			unselectedStudents(){
				if( !this.selectedStudent ){
					return this.students;
				}

				const selectedStudentRid = this.selectedStudent.STUDENT_RID;
				return this.students.filter(function(student){
					return student.STUDENT_RID !== selectedStudentRid;
				});
			},
		},
		watch: {
			'$route.name'( to, from ) {
				if( this.role === 'parent' ) {
					if( to === 'HomePage' && this.$store.state.students.length > 1 ) {
						this.$store.commit( 'setSelectedStudentRID', 0 );
					}
				}
			},
			showLocaleDialog( newVal, oldVal ) {
				if( this.userIsAdmin ) {
					if( oldVal !== newVal && newVal ) {
						if( Object.keys( this.adminLocale ).length > 0 ) {
							this.selectedLocale = this.getSelectedLocale.LOCALE_ID;
						}
					}
				}
			},
		},
		methods: {
			...mapActions(['resetSelectedStudentRID']),
			...mapMutations(['setAdminRole',]),	
			logout() {
				this.$store.dispatch('logout', { clean: true });
			},
			switchAdminRole(){
				if(this.role === 'parent'){
					this.setAdminRole('student');
				} else if(this.role === 'student'){
					this.setAdminRole('parent');
				}
			},
			updateRoute(route) {
				this.isExpanded = false;
				this.$router.push({path: route});
			},
			setSelectedStudentAndGoToWelcomeScreen(studentRid) {
				this.$store.dispatch('updateSelectedStudentRID', studentRid);
				this.studentDropdownIsExpanded = false;
				this.$router.push({ name: 'HomePage' });
			},
			navigateToHomePage() {
				if( this.role === 'parent' ) {
					if( this.$route.name === 'ParentHome' || this.$route.name === 'HomePage' ) {
						if( this.$store.state.students.length > 1 ) {
							if( !!this.selectedStudent ) {
								if( Object.keys( this.selectedStudent ).length > 0 ) {
									this.$router.push({ name: 'HomePage' });

									// If on Student HomePage convert to no student selected
									this.$store.commit( 'setSelectedStudentRID', 0 );
								}
							}
						} else {
							this.$router.push({ name: 'HomePage' });
						}
					} else {
						this.$router.push({ name: 'HomePage' });
					}
				} else {
					this.$router.push({ name: 'HomePage' });
				}
			},
			loadLocales() {
				const self = this;

				let locales = new Locales({});

				locales.get().then(response => {
					self.locales = locales.getResponseData();

					if( self.locales.length > 0 ) {
						if( self.userIsAdmin ) {
							if( Object.keys( self.adminLocale ).length > 0 ) {
								self.selectedLocale = self.adminLocale.LOCALE_ID;
							} else {
								self.selectedLocale = self.locales[0].LOCALE_ID;
								self.$store.commit( 'setAdminLocale', self.locales.find( locale => self.selectedLocale === locale.LOCALE_ID ) );
							}
						} else {
							self.selectedLocale = self.locales[0].LOCALE_ID;
							self.$store.commit( 'setProfileLocale', self.locales.find( locale => self.selectedLocale === locale.LOCALE_ID ) );
						}
					}
				});
			},
			switchLanguageDisplay() {
				const selectedLocaleOption = this.locales.find( locale => this.selectedLocale === locale.LOCALE_ID );

				this.userIsAdmin ?
					this.$store.commit( 'setAdminLocale', selectedLocaleOption ) :
					this.$store.commit( 'setProfileLocale', selectedLocaleOption );
				this.$i18n.locale = selectedLocaleOption.LOCALE_CODE;
				if(
					selectedLocaleOption.LOCALE_CODE !== 'sa-us' &&
					selectedLocaleOption.LOCALE_CODE !== 'en-us'
				) {
					moment.locale( this.getSelectedLocale.LOCALE_CODE );
					this.$emit( 'updateLocales', this.getSelectedLocale.LOCALE_CODE );
				} else {
					moment.locale( 'en' );
					this.$emit( 'updateLocales', 'en' );
				} 
				this.showLocaleDialog = false;
			},
			isAboveMaxLength() {
				let headerLabelsLength = 0;

				headerLabelsLength += ( this.$t( 'MAIN_CONTENT.commonContent.homeHeaderLink' ) ).length;
				headerLabelsLength += ( this.$t( 'MAIN_CONTENT.HelpButton.helpLink' ) ).length;

				if( this.role === 'student' ) {
					headerLabelsLength += ( this.$t( 'MAIN_CONTENT.Header.account' ) ).length;
				} else {
					headerLabelsLength += ( this.profile.USER_FIRST_NAME + this.profile.USER_LAST_NAME ).length;
				}

				return headerLabelsLength > 25;
			}
		},
		mounted() {
			if( this.userIsAdmin ) {
				this.loadLocales();
			}
		}
	}
</script>

<style scoped>
 .dropdown-toggle::after {
		content: none !important;
	}

	.show-menu {
		display: inherit !important;
	}
</style>
